<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">The Man Who Hated Mars</a></li>
<li><a href="#/Text/Section0004">Suite Mentale</a></li>
<li><a href="#/Text/Section0005">Viewpoint</a></li>
<li><a href="#/Text/Section0006">The Unnecessary Man</a></li>
<li><span href="#/Text/Section0007" title="Link target outside of Sample">The Penal Cluster</span></li>
<li><span href="#/Text/Section0008" title="Link target outside of Sample">What The Left Hand Was Doing</span></li>
<li><span href="#/Text/Section0009" title="Link target outside of Sample">Fifty Per Cent Prophet</span></li>
<li><span href="#/Text/Section0010" title="Link target outside of Sample">The Foreign Hand Tie</span></li>
<li><span href="#/Text/Section0011" title="Link target outside of Sample">A World by the Tale</span></li>
<li><span href="#/Text/Section0012" title="Link target outside of Sample">Thin Edge</span></li>
<li><span href="#/Text/Section0013" title="Link target outside of Sample">His Master's Voice</span></li>
<li><span href="#/Text/Section0014" title="Link target outside of Sample">Spatial Delivery</span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?bf770608